import { useEffect } from "react";
import { Redirect, Route, Switch, useLocation, useSearch } from "wouter";
import { legacyRacingDestination } from "@/features/racing/routes";
import SchedulePage from "@/features/schedule/SchedulePage";

import VerifyPage from "@/features/fairness/VerifyPage";
import LeaderboardPage from "@/features/leaderboards/LeaderboardPage";
import MarketplacePage from "@/features/marketplace/MarketplacePage";
import PacksPage from "@/features/packs/PacksPage";
import PlayerPage from "@/features/player/PlayerPage";
import RacingPage from "@/features/racing/RacingPage";
import SyndicatesPage from "@/features/syndicates/SyndicatesPage";

import { AppShell } from "./AppShell";
import { PendingProviderConnection } from "@/session/PendingProviderConnection";

export default function App() {
  const [location, navigate] = useLocation();
  const search = useSearch();
  const legacyDestination = legacyRacingDestination(location, search);
  useEffect(() => {
    if (legacyDestination) navigate(legacyDestination, { replace: true });
  }, [legacyDestination, navigate]);
  const isHomeRoute = location === "/app" || location === "/app/";
  const isRacingRoute =
    location === "/app/racing" || location.startsWith("/app/racing/");

  return (
    <AppShell>
      <PendingProviderConnection />
      {isHomeRoute || isRacingRoute ? (
        // Legacy URL normalization and Home tab/query changes preserve this
        // one player. Schedule deliberately does not mount a hidden renderer.
        <RacingPage />
      ) : (
        <Switch>
          <Route component={SchedulePage} path="/app/schedule" />
          <Route component={PacksPage} path="/app/packs" />
          <Route component={PlayerPage} path="/app/player/horse/:horseId" />
          <Route component={PlayerPage} path="/app/player/:tab" />
          <Route component={PlayerPage} path="/app/player" />
          <Route component={LeaderboardPage} path="/app/leaderboards" />
          <Route component={LeaderboardPage} path="/app/leaderboards/:tab" />
          <Route component={MarketplacePage} path="/app/marketplace" />
          <Route component={SyndicatesPage} path="/app/syndicates" />
          <Route component={VerifyPage} path="/app/verify/:raceId" />
          <Route component={VerifyPage} path="/app/verify" />
          <Route>
            <Redirect to="/app/" />
          </Route>
        </Switch>
      )}
    </AppShell>
  );
}
